import { AppFlavour }                                       from "configs/AppFlavours";
import { useGlobalConfig }                                  from "context/GlobalContext";
import { SSOMessage }                                       from "features/root/SSOComponent";
import { useEffect }                                        from "react"
import { useSelector, useDispatch }                         from "react-redux";
import { Navigate }                                         from "react-router-dom";
import { SESSION_ACTIONS }                                  from "store/actions/sessionActions";
import { getPopupParams, prepareRedirectURL }               from "./loginHelper";
import styles                                               from './login.module.scss';
import Box                                                  from "@mui/material/Box";
import { AppBar, Button, styled, Toolbar, Typography }      from "@mui/material"
import logo                                                 from '@/assets/img/bidgely.png';
import lock                                                 from '@/assets/img/lock.png';
/*

Login component is responsible for : 
1. Structuring the return url.
2. Find correct mapping of sso Lambda for execution environment.
3. Initiating redirect to the sso Lambda with return URL.
NOTE : This is a hardcoded page as translations / configs are not avialable till
       this point.
*/


const BglAppBar = styled(AppBar)(({ theme }) => ({
  width: '100%',
  backgroundColor : 'white',
  color: 'black'
}))


export const LoginComponent = () => {
  
  const isLoggedIn = useSelector((state : any) => state.session.isLoggedIn);
  const error = useSelector((state : any) => state.session.error);
  const { rc } = useGlobalConfig();
  const appFlavour = AppFlavour.getFlavour();
  const dispatch = useDispatch();

  //handle SSO message
  const handleSSOMessage = (event : MessageEvent) => {
    const ssoMessage : SSOMessage = event.data;
    if(ssoMessage.errorCode){
      //dispatch error event
      dispatch(SESSION_ACTIONS.SSO_FAILED(ssoMessage.errorCode));
    } else if(ssoMessage.accessToken){
      //dispatch success event;
      rc.session.setAccessToken(ssoMessage.accessToken);
      dispatch(SESSION_ACTIONS.SET_LOGGED_IN(ssoMessage.accessToken));
    }
  }

 const initLogin = () =>{
  window.addEventListener("message", handleSSOMessage);
  if(!isLoggedIn){
    const redirectURL = prepareRedirectURL(rc, appFlavour);
    const popupParams = getPopupParams();
    window.open(redirectURL.href, "login", popupParams);
  }
 }
 
  //Unmount handler 
  useEffect(()=> ()=> window.removeEventListener("message",handleSSOMessage));

  return(
    <>
    {
      isLoggedIn ? 
      <Navigate to="/dashboard" replace></Navigate> 
      :
        error 
            ? <div>Unauthorized to access this page</div>
            :
            <div className={styles.root}>
            <BglAppBar position="sticky">
              <Toolbar>
                <img className={styles.logo} src={logo}
                  alt="Bidgely"/>
                <Typography
                  noWrap
                  component="div"
                  sx={{ typography: { md: 'h6', xs: 'body2' } }}>
                  Event Management Console
                </Typography>
      
                <Box sx={{ flexGrow: 1 }} />
      
              </Toolbar>
            </BglAppBar>
            <main className={styles.mainCont}>
              <div>
                <img className={styles.lock} src={lock}
                    alt="Locked"/>
              </div>
              <div className={styles.contentLine}>
                Log in to your Utility Account
              </div>
              <div className={styles.subText}>
                Once you log in, the console will open up here.
              </div>
              <Button sx={{ backgroundColor : "#1467D5",
                            color : "#fff",
                            height : "40px",
                            width : "170px",
                            fontSize : "14px"
                          }}
              size="large"
              variant="contained"
            onClick={initLogin}>
                 Log In
              </Button>
            </main>
            <div className={styles.footerCont}>
              <Typography color="primary" 
                sx={{ textDecoration: 'underline', marginBottom: '10px'}}>
              </Typography>
              <Typography>@2023, Bidgely Inc.</Typography>
            </div>
          </div>
    }
    </>
  )
}